import styled from 'styled-components';
import PrimaryButton from 'components/Button/PrimaryButton';

type InfoReqButtonProps = {
  disabled: boolean,
  onClick: () => void,
  currentStep: number,
  totalSteps: number,
}

const InfoReqButton = ({ disabled, onClick, currentStep, totalSteps }: InfoReqButtonProps) => (
  <ButtonContainer onlyStep={(totalSteps === 1)}>
    {(totalSteps > 1) && (
      <div>Step {currentStep} of {totalSteps}</div>
    )}
    <PrimaryButton
      data-testid="inforeq-submit"
      disabled={disabled}
      onClick={onClick}
      text={(totalSteps === 1 || currentStep === totalSteps) ? 'Submit' : 'Next Step'}
    />
  </ButtonContainer>
);

export default InfoReqButton;

const ButtonContainer = styled.div<{ onlyStep?: boolean }>`
  display: flex;
  align-items: center;
  justify-content: ${({ onlyStep }) => (onlyStep ? 'flex-end' : 'space-between')};
  margin: 15px 0px;
`;
